module.exports = __webpack_public_path__ + "img/build-drain-grating-1.ee970bc2.jpg";